import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe
const stripePromise = loadStripe('pk_live_51SJYWnBgpdDdfPYuyhkdCbfW6qSNkYEeKYK7oYB1xZuGXd8rEpkTFWOYIeI8UKS8zgNK2uN9YzvbddznjS5kVW3E006khrRJUg');

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const StripeCheckout = ({ priceId, organizationId, onSuccess, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCheckout = async () => {
    setLoading(true);
    setError(null);

    try {
      const savedToken = localStorage.getItem('token');
      
      // Create checkout session
      const response = await fetch(`${API_URL}/stripe/create-checkout-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${savedToken}`
        },
        body: JSON.stringify({
          priceId: priceId,
          organizationId: organizationId
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to create checkout session');
      }

      const { url } = await response.json();

      // Redirect to Stripe Checkout
      window.location.href = url;

    } catch (err) {
      console.error('Checkout error:', err);
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
        <h3 className="font-semibold text-blue-900 dark:text-blue-100 mb-2">
          💳 AlpenScreen Basic
        </h3>
        <p className="text-sm text-blue-800 dark:text-blue-200 mb-3">
          CHF 49.00 / Monat
        </p>
        <ul className="text-sm text-blue-700 dark:text-blue-300 space-y-1 mb-4">
          <li>✓ Unlimited Screens</li>
          <li>✓ Basis Features</li>
          <li>✓ Live Updates</li>
          <li>✓ Support</li>
        </ul>
      </div>

      {error && (
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
          <p className="text-sm text-red-800 dark:text-red-200">
            ❌ {error}
          </p>
        </div>
      )}

      <div className="flex gap-3">
        <button
          onClick={handleCheckout}
          disabled={loading}
          className="flex-1 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white px-6 py-3 rounded-lg font-medium transition-colors"
        >
          {loading ? (
            <span className="flex items-center justify-center gap-2">
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              Processing...
            </span>
          ) : (
            '💳 Proceed to Checkout'
          )}
        </button>
        
        {onCancel && (
          <button
            onClick={onCancel}
            disabled={loading}
            className="px-6 py-3 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
          >
            Cancel
          </button>
        )}
      </div>

      <p className="text-xs text-gray-500 dark:text-gray-400 text-center">
        🔒 Secure payment powered by Stripe
      </p>
    </div>
  );
};

export default StripeCheckout;